import { NavButtonData, MenuRouterAction } from '@/types/nav-buttons';
import { toggleLanguage } from '@/utils/locale';

export const advertiserNavButtons: NavButtonData[] = [
  {
    name: 'toggle_language',
    icon: '/assets/icons/language.svg',
    action: (({ $route, $router }) => {
      toggleLanguage($route, $router);
    })as MenuRouterAction

  }
];

export const storeOwnerNavButtons: NavButtonData[] = [
  {
    name: 'toggle_language',
    icon: '/assets/icons/language.svg',
    action: (({ $route, $router }) => {
      toggleLanguage($route, $router);
    })as MenuRouterAction

  },
];

export const sharedNavButtons: NavButtonData[] = [
  {
    name: 'toggle_language',
    icon: '/assets/icons/language.svg',
    action: (({ $route, $router }) => {
      toggleLanguage($route, $router);
    })as MenuRouterAction

  }
];